import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { convertToMoney } from '@woovi/utils';

import type { PaymentPixAutomaticTitle_subscription$key } from './__generated__/PaymentPixAutomaticTitle_subscription.graphql';

type PaymentPixAutomaticInfoProps = {
  pixAutomatic: PaymentPixAutomaticTitle_subscription$key;
};

export const PaymentPixAutomaticTitle = (
  props: PaymentPixAutomaticInfoProps,
): ReactNode => {
  const { t } = useTranslation();
  const pixAutomatic = useFragment<PaymentPixAutomaticTitle_subscription$key>(
    graphql`
      fragment PaymentPixAutomaticTitle_subscription on PaymentSubscription {
        value
        company {
          projectType
          nameFriendly
        }
      }
    `,
    props.pixAutomatic,
  );

  const title = t('Approve the Pix Automatic of {{value}} to {{merchant}}', {
    value: convertToMoney(pixAutomatic?.value),
    merchant: pixAutomatic.company?.nameFriendly,
  });

  return (
    <Stack sx={{ alignItems: 'center' }}>
      <Typography variant='h5' fontWeight='bold' textAlign='center'>
        {title}
      </Typography>
    </Stack>
  );
};
